import { Box, Button, Typography } from '@mui/material';

import { SquareIcon } from '@/components/common';
import { SidebarItem, SportsSidebarCategory } from '@/types';
import { SportsFallbackIcon } from '../SportsFallbackIcon';

interface SportsMobileSidebarItemProps {
  category: SportsSidebarCategory;
  isActive: boolean;
  activeId?: string | number | null;
  onClick: (item: SidebarItem) => void;
  buttonRef?: (el: HTMLButtonElement | null) => void;
}

export const SportsMobileSidebarItem = ({
  category,
  isActive,
  activeId,
  onClick,
  buttonRef,
}: SportsMobileSidebarItemProps) => {
  const name = category.category || (category as any).sport || '';
  const image = category.img || null;

  const handleClick = () => {
    onClick(category);
  };

  return (
    <Button
      ref={buttonRef}
      onClick={handleClick}
      variant={isActive ? 'contained' : 'outlined'}
      sx={{
        flexShrink: 0,
        borderRadius: 1,
        textTransform: 'none',
        p: 1,
        minWidth: 64,
        height: 64,
        transition: 'all 0.2s',
        bgcolor: isActive ? 'action.selected' : 'transparent',
        border: 'none',
        color: isActive ? 'text.primary' : 'text.secondary',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 1,
        '&:hover': {
          bgcolor: isActive ? 'action.selected' : 'action.hover',
        },
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: 20,
          height: 20,
          position: 'relative',
        }}
      >
        <SquareIcon src={image} alt={name} size={20} fallback={<SportsFallbackIcon size={20} />} />
      </Box>
      <Typography
        component="span"
        sx={{ fontSize: '0.75rem', fontWeight: 600, lineHeight: 1, whiteSpace: 'nowrap' }}
      >
        {name}
      </Typography>
    </Button>
  );
};
